module.exports = __webpack_public_path__ + "img/me_quad.68b27087.jpg";